import baseAPI from "@/http";

const router = "api/geral/municipio";

export const municipioAPI = {
  get: id => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(`${router}`),
  update: (payload) => baseAPI.put(`${router}`, payload),
  listarChamadasPublicas: () => baseAPI.get(`${router}/get-chamadas-publicas`)
};
